import {LazyLoadEvent} from 'primeng/api';

export class VendorFilterDto {
  vendorSearchType?: any;
  vendorSearchValue?: any;
  sortOrder?: any;
  startLetter?: any;
  rows?: any;
  first?: any;
}
